<div class="sandbox-banner" [class.sandbox-banner--compact]="compact" [class.sandbox-banner--busy]="inProgress" role="status" aria-live="polite" *ngIf="isSandbox">
  <span class="sandbox-banner__tag">Sandbox</span>
  <span class="sandbox-banner__text">
    <strong>You are in the Sandbox.</strong>
    This is a copy for testing. Changes made here never affect your live data.
  </span>

  <!-- Data age / progress. Only when signed in on the full layout. -->
  <span class="sandbox-banner__status" *ngIf="live && !loadFailed">
    <ng-container *ngIf="company; else noCompany">
      <ng-container *ngIf="inProgress">
        <span class="sandbox-banner__spinner" aria-hidden="true"></span>
        <strong>Refreshing {{ company.company_name }} from live&hellip;</strong>
        <span *ngIf="progressSince">started {{ progressSince }}</span>
        <span *ngIf="company.refresh?.requested_by">by {{ company.refresh.requested_by }}</span>
      </ng-container>
      <ng-container *ngIf="!inProgress">
        <ng-container *ngIf="!company.enabled">
          {{ company.company_name }} has no sandbox. Barkani staff turn it on in the live admin.
        </ng-container>
        <ng-container *ngIf="company.enabled && dataAge">
          Data copied from live <strong [title]="dataAgeExact">{{ dataAge }}</strong>
        </ng-container>
        <ng-container *ngIf="company.enabled && !dataAge">
          No data has been copied for {{ company.company_name }} yet.
        </ng-container>
        <span class="sandbox-banner__error" *ngIf="lastError" [title]="lastError">Last refresh failed.</span>
      </ng-container>
    </ng-container>
    <ng-template #noCompany>
      <ng-container *ngIf="sharedDataAge">Shared data copied from live {{ sharedDataAge }}</ng-container>
    </ng-template>
  </span>

  <span class="sandbox-banner__actions">
    <button
      *ngIf="live && !loadFailed && company && mayRefresh && !inProgress"
      type="button"
      class="sandbox-banner__button"
      [disabled]="!company.can_refresh || starting"
      [title]="blockedReason || 'Delete the sandbox data for this company and copy the live data again'"
      (click)="confirmRefresh()">
      {{ starting ? 'Starting…' : 'Refresh from live…' }}
    </button>
    <ng-content></ng-content>
    <a *ngIf="liveUrl" class="sandbox-banner__link" [href]="liveUrl" rel="noopener">Back to live site</a>
  </span>
</div>
